document.addEventListener("DOMContentLoaded", function () {
    const replatformBox = document.querySelector('.custom-replatforming-setup');
    const domainBox = document.querySelector('.custom_domain_set');
    const subscriptionInputs = document.querySelectorAll('.custom-foundation-package .subscription_input');
    const totalPriceEls = document.querySelectorAll('.total-price');
    const form = document.querySelector('#bundle-cart-form');
    const hiddenWrapper = document.querySelector('#bundle-hidden-inputs');
    const selectedItemsWrapper = document.querySelector('.selected-items');
    function formatMoney(price) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD'}).format(price);
    }
    function calculateTotal() {
        let total = 0;
        const foundationSelected = document.querySelector( '.custom-foundation-package input[type="radio"].subscription_input:checked');
        if (foundationSelected) {
            total += Number( foundationSelected.dataset.price || 0 ) / 100;
        }
        document.querySelectorAll('.shopify_developer_block').forEach((block) => {
            if (block.classList.contains('custom-foundation-package')) {
                return;
            }
            const mainCheckbox = block.querySelector('.custom-input-check');
            if (!mainCheckbox || !mainCheckbox.checked) {
                return;
            }
            const radioVariants = block.querySelectorAll('.product_wrapper input[type="radio"].subscription_input');
            const checkboxVariants = block.querySelectorAll('.product_wrapper input[type="checkbox"].subscription_input:not(.custom-input-check)');
            if (radioVariants.length === 0 && checkboxVariants.length === 0) {
                total += Number( mainCheckbox.dataset.price || 0 ) / 100;
            }
            const checkedRadio = block.querySelector('.product_wrapper input[type="radio"].subscription_input:checked');
            if (checkedRadio) {
                total += Number( checkedRadio.dataset.price || 0 ) / 100;
            }
            checkboxVariants.forEach((checkbox) => {
                if (checkbox.checked) {
                    total += Number(
                        checkbox.dataset.price || 0
                    ) / 100;
                }
            });
        });
        totalPriceEls.forEach((el) => {
            el.innerHTML = formatMoney(total);
        });
    }
    function updateSelectedItems() {
        if (!selectedItemsWrapper) return;
        selectedItemsWrapper.innerHTML = '';
        const foundationSelected = document.querySelector('.custom-foundation-package input[type="radio"].subscription_input:checked');
        if (foundationSelected) {
            addSelectedItem(`Base project type: ${foundationSelected.dataset.title}`, foundationSelected.dataset.price, foundationSelected.value,  false);
        }
        document.querySelectorAll('.shopify_developer_block').forEach((block) => {
            if (block.classList.contains('custom-foundation-package')) {
                return;
            }
            const mainCheckbox = block.querySelector('.custom-input-check');
            if (!mainCheckbox || !mainCheckbox.checked) {
                return;
            }
            const blockTitle =
                mainCheckbox.closest('.checkbox')?.querySelector('h4')
                    ?.textContent
                    ?.trim() || mainCheckbox.dataset.title;
            const radioVariants = block.querySelectorAll('.product_wrapper input[type="radio"].subscription_input');
            const checkboxVariants = block.querySelectorAll(
                '.product_wrapper input[type="checkbox"].subscription_input:not(.custom-input-check)'
            );
            if (radioVariants.length === 0 && checkboxVariants.length === 0) {
                addSelectedItem(
                    blockTitle,
                    mainCheckbox.dataset.price,
                    mainCheckbox.value
                );
            }
            const checkedRadio = block.querySelector(
                '.product_wrapper input[type="radio"].subscription_input:checked'
            );
            if (checkedRadio) {
                addSelectedItem(
                    `${blockTitle}: ${checkedRadio.dataset.title}`,
                    checkedRadio.dataset.price,
                    checkedRadio.value
                );
            }
            checkboxVariants.forEach((checkbox) => {
                if (checkbox.checked) {
                    addSelectedItem(
                        `${blockTitle}: ${checkbox.dataset.title}`,
                        checkbox.dataset.price,
                        checkbox.value
                    );
                }
            });
        });
    }
    function addSelectedItem(title, price, variantId = '', showRemove = true) {
        const row = document.createElement('div');
        row.classList.add('flex-row');
        row.dataset.variantId = variantId;
        row.innerHTML = `
            <div class="item-content">
                <div class="item-info">
                    <h6 class="title">${title}</h6>
                    <p class="price">${formatMoney((price || 0) / 100)}</p>
                </div>

                ${showRemove ? `<button type="button" class="remove-item">✕</button>` : ''}
            </div>
        `;
        selectedItemsWrapper.appendChild(row);
    }
    function handleVisibility(selectedInput) {
        if (!selectedInput) return;
        const title = selectedInput.dataset.title.toLowerCase().trim();
        if (replatformBox) {
            replatformBox.style.display = '';
        }
        if (domainBox) {
            domainBox.style.display = '';
        }
        if (title === 'new store') {
            if (replatformBox) {
                replatformBox.style.display = 'none';
            }
        }
        if (title === 'all service quotes builder') {
            if (replatformBox) {
                replatformBox.style.display = 'none';
            }
            if (domainBox) {
                domainBox.style.display = 'none';
            }
        }

        if (title === 'replatform') {
            if (domainBox) {
                domainBox.style.display = 'none';
            }
        }
    }
    function updateBundleProducts(existingBundleId = null) {
        if (!form || !hiddenWrapper) return;
        hiddenWrapper.innerHTML = '';
        const foundationSelected = document.querySelector(
            '.custom-foundation-package input[type="radio"].subscription_input:checked'
        );
        if (!foundationSelected) return;
        const bundleId = existingBundleId || ('bundle_' + Date.now());
        let itemIndex = 0;
        createBundleItem(
            foundationSelected.value,
            true
        );
        if (
            foundationSelected.dataset.title.toLowerCase().trim() === 'replatform'
        ) {
            const selectedPlatform = document.querySelector(
                '.select-input .box-select li.selected'
            );
            if (selectedPlatform) {
                addProperty(
                    itemIndex - 1,
                    'Existing Platform',
                    selectedPlatform.textContent.trim()
                );
            }
        }
        document.querySelectorAll('.shopify_developer_block').forEach((block) => {
            if (block.classList.contains('custom-foundation-package')) {
                return;
            }
            const mainCheckbox = block.querySelector('.custom-input-check');
            if (!mainCheckbox || !mainCheckbox.checked) {
                return;
            }
            const radioVariants = block.querySelectorAll(
                '.product_wrapper input[type="radio"].subscription_input'
            );
            const checkboxVariants = block.querySelectorAll(
                '.product_wrapper input[type="checkbox"].subscription_input:not(.custom-input-check)'
            );
            if (radioVariants.length === 0 && checkboxVariants.length === 0) {
                createBundleItem(mainCheckbox.value);
            }
            const checkedRadio = block.querySelector(
                '.product_wrapper input[type="radio"].subscription_input:checked'
            );
            if (checkedRadio) {
                createBundleItem(checkedRadio.value);
            }
            checkboxVariants.forEach((checkbox) => {
                if (checkbox.checked) {
                    createBundleItem(checkbox.value);
                }
            });
        });
        function createBundleItem(variantId, isMain = false) {
            addHiddenInput(
                `items[${itemIndex}][id]`,
                variantId
            );
            addHiddenInput(
                `items[${itemIndex}][quantity]`,
                1
            );
            addHiddenInput(
                `items[${itemIndex}][properties][_bundle_id]`,
                bundleId
            );
            if (isMain) {
                addHiddenInput(
                    `items[${itemIndex}][properties][_is_main]`,
                    'true'
                );
            }
            itemIndex++;
        }
        function addProperty(index, name, value) {
            addHiddenInput(
                `items[${index}][properties][${name}]`,
                value
            );
        }
        function addHiddenInput(name, value) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = name;
            input.value = value;
            hiddenWrapper.appendChild(input);
        }
    }
    subscriptionInputs.forEach((input) => {
        input.addEventListener('change', function () {
            const wrapper = this.closest('.product_wrapper');
            if (wrapper) {
                wrapper.querySelectorAll('.radiobox__block').forEach((block) => {
                    block.classList.remove('active');
                });
            }
            if (this.checked) {
                const currentBox = this.closest('.radiobox__block');
                if (currentBox) {
                    currentBox.classList.add('active');
                }
                handleVisibility(this);
            }
            calculateTotal();
            updateBundleProducts();
            updateSelectedItems();
        });
    });
    document.querySelectorAll('.subscription_input.custom-input-check').forEach((input) => {
        input.addEventListener('change', function () {
            const parentBlock = this.closest('.shopify_developer_block');
            if (!parentBlock) return;
            if (this.checked) {
                parentBlock.classList.add('active');
            } else {
                parentBlock.classList.remove('active');
            }
            calculateTotal();
            updateBundleProducts();
            updateSelectedItems();
        });
    });
    document.querySelectorAll('.product_wrapper .subscription_input:not(.custom-input-check)').forEach((input) => {
        input.addEventListener('change', function () {
            if (this.type === 'radio') {
                const wrapper = this.closest('.product_wrapper');
                if (wrapper) {
                    wrapper.querySelectorAll('.radiobox__block').forEach((block) => {
                        block.classList.remove('active');
                    });
                }
                const currentBox = this.closest('.radiobox__block');
                if (currentBox) {
                    currentBox.classList.add('active');
                }
            }
            if (this.type === 'checkbox') {
                const currentBox = this.closest('.radiobox__block');
                if (currentBox) {
                    if (this.checked) {
                        currentBox.classList.add('active');
                    } else {
                        currentBox.classList.remove('active');
                    }
                }
            }
            calculateTotal();
            updateBundleProducts();
            updateSelectedItems();
        });
    });
    document.querySelectorAll('.select-input').forEach((dropdown) => {
        const input = dropdown.querySelector('input');
        const list = dropdown.querySelector('.box-select');
        const items = dropdown.querySelectorAll('.box-select li');
        const errorEl = dropdown.querySelector('.platform-error');
        if (!input || !list) return;
        input.addEventListener('click', function (e) {
            e.stopPropagation();
            document.querySelectorAll('.box-select').forEach((ul) => {
                if (ul !== list) {
                    ul.classList.remove('active');
                }
            });
            list.classList.toggle('active');
        });
        items.forEach((item) => {
            item.addEventListener('click', function () {
                input.value = item.textContent.trim();
                items.forEach((li) => {
                    li.classList.remove('selected');
                });
                item.classList.add('selected');
                list.classList.remove('active');
                if (errorEl) {
                    errorEl.style.display = 'none';
                }
                calculateTotal();
                updateBundleProducts();
                updateSelectedItems();
            });
        });
    });
    document.addEventListener('click', function (e) {
        const btn = e.target.closest('.remove-item');
        if (!btn) return;
        const row = btn.closest('.flex-row');
        if (!row) return;
        const variantId = row.dataset.variantId;
        const input = document.querySelector(
            `.subscription_input[value="${variantId}"]`
        );
        if (!input) return;
        input.checked = false;
        const radioBox = input.closest('.radiobox__block');
        if (radioBox) {
            radioBox.classList.remove('active');
        }
        const developerBlock = input.closest('.shopify_developer_block');
        if (
            developerBlock &&
            input.classList.contains('custom-input-check')
        ) {
            developerBlock.classList.remove('active');
        }
        calculateTotal();
        updateBundleProducts();
        updateSelectedItems();
    });
    document.addEventListener('click', function () {
        document.querySelectorAll('.box-select').forEach((list) => {
            list.classList.remove('active');
        });
    });
    calculateTotal();
    updateBundleProducts();
    updateSelectedItems();
    if (form) {
        form.addEventListener('submit', async function (e) {
            e.preventDefault();
            try {
                const foundationSelected = document.querySelector(
                    '.custom-foundation-package input[type="radio"].subscription_input:checked'
                );
                if (
                    foundationSelected &&
                    foundationSelected.dataset.title.toLowerCase().trim() === 'replatform'
                ) {
                    const selectedPlatform = document.querySelector('.select-input .box-select li.selected');
                    const platformError = document.querySelector('.platform-error');
                    if (!selectedPlatform) {
                        if (platformError) {
                            platformError.style.display = 'block';
                        }
                        return;
                    }
                    if (platformError) {
                        platformError.style.display = 'none';
                    }
                }
                const cart = await fetch('/cart.js').then(res => res.json());
                let existingBundleId = null;
                if (foundationSelected) {
                    const existingMainProduct = cart.items.find(item => {
                        return (
                            String(item.id) === String(foundationSelected.value) &&
                            item.properties &&
                            item.properties._is_main
                        );
                    });
                    if (existingMainProduct) {
                        existingBundleId = existingMainProduct.properties._bundle_id;
                    }
                }
                updateBundleProducts(existingBundleId);
                const formData = new FormData(form);
                const items = [];
                const itemIds = [];
                const quantities = [];
                const bundleIds = [];
                const mainFlags = [];
                const itemProperties = [];
                for (let [key, value] of formData.entries()) {
                    const itemIdMatch = key.match(/items\[(\d+)\]\[id\]/);
                    if (itemIdMatch) {
                        const index = itemIdMatch[1];
                        itemIds[index] = value;
                    }
                    const qtyMatch = key.match(/items\[(\d+)\]\[quantity\]/);
                    if (qtyMatch) {
                        const index = qtyMatch[1];
                        quantities[index] = value;
                    }
                    const bundleMatch = key.match(/items\[(\d+)\]\[properties\]\[_bundle_id\]/);
                    if (bundleMatch) {
                        const index = bundleMatch[1];
                        bundleIds[index] = value;
                    }
                    const mainMatch = key.match(/items\[(\d+)\]\[properties\]\[_is_main\]/);
                    if (mainMatch) {
                        const index = mainMatch[1];
                        mainFlags[index] = value;
                    }
                    const propertyMatch = key.match(/items\[(\d+)\]\[properties\]\[(.*?)\]/);
                    if (
                        propertyMatch &&
                        propertyMatch[2] !== '_bundle_id' &&
                        propertyMatch[2] !== '_is_main'
                    ) {
                        const index = propertyMatch[1];
                        if (!itemProperties[index]) {
                            itemProperties[index] = {};
                        }
                        itemProperties[index][propertyMatch[2]] = value;
                    }
                }
                for (let index = 0; index < itemIds.length; index++) {
                    const id = itemIds[index];
                    if (!id || isNaN(Number(id))) {
                        continue;
                    }
                    const existingCartItem = cart.items.find(cartItem => {
                        return (
                            String(cartItem.id) === String(id) &&
                            cartItem.properties &&
                            cartItem.properties._bundle_id === bundleIds[index]
                        );
                    });
                    if (existingCartItem) {
                        await fetch('/cart/change.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                id: existingCartItem.key,
                                quantity: 0
                            })
                        });
                    }
                    const item = {
                        id: Number(id),
                        quantity: Number(quantities[index] || 1),
                        properties: {
                            _bundle_id: bundleIds[index]
                        }
                    };
                    if (mainFlags[index]) {
                        item.properties._is_main = 'true';
                    }
                    if (itemProperties[index]) {
                        Object.assign(
                            item.properties,
                            itemProperties[index]
                        );
                    }
                    items.push(item);
                }
                if (!items.length) {
                    return;
                }
                const addResponse = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        items: items
                    })
                });
                if (!addResponse.ok) {
                    throw new Error('Failed to add items to cart');
                }
                window.location.href = '/checkout';
                return;
            } catch (error) {
                console.error('Cart Error:', error);
            }
        });
    }
    window.addEventListener('pageshow', function () {
        document.querySelectorAll('.subscription_input').forEach(function (input) {
            const block = input.closest('.radiobox__block');
            const developer = input.closest('.shopify_developer_block');

            if (input.checked) {
                block?.classList.add('active');
                developer?.classList.add('active');
            } else {
                block?.classList.remove('active');
                developer?.classList.remove('active');
            }

        });
        calculateTotal();
        updateBundleProducts();
        updateSelectedItems();

    });
});